import { ContentChild, Directive, Input } from '@angular/core';
import { NgModel } from '@angular/forms';

@Directive({
  selector: '[ipSharedRequiredGroupMember]',
  standalone: true,
})
export class RequiredGroupMemberDirective {
  @Input('ipSharedRequiredGroupMember') groupName!: string;
  @ContentChild(NgModel) model!: NgModel;
}
